import { Card } from "@shadcn-in-nx/ui/card";
import { useTranslation } from "react-i18next";

export function SupportFAQ() {
    const { t } = useTranslation();

    const faqs = [
        { question: t("billing.supportPlans.faq.q1"), answer: t("billing.supportPlans.faq.a1") },
        { question: t("billing.supportPlans.faq.q2"), answer: t("billing.supportPlans.faq.a2") },
        { question: t("billing.supportPlans.faq.q3"), answer: t("billing.supportPlans.faq.a3") },
        { question: t("billing.supportPlans.faq.q4"), answer: t("billing.supportPlans.faq.a4") },
        { question: t("billing.supportPlans.faq.q5"), answer: t("billing.supportPlans.faq.a5") },
    ];

    return (
        <div className="space-y-4">
            <h3 className="text-lg font-semibold">{t("billing.supportPlans.faq.title")}</h3>
            <div className="space-y-3">
                {faqs.map((faq, idx) => (
                    <Card key={idx} className="p-4 border border-border/50">
                        <h4 className="font-medium mb-2 flex items-start gap-2">
                            <span className="text-blue-600 flex-shrink-0">Q:</span>
                            <span>{faq.question}</span>
                        </h4>
                        <p className="text-sm text-muted-foreground pl-6">{faq.answer}</p>
                    </Card>
                ))}
            </div>
        </div>
    );
}
